import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import toast from "react-hot-toast";
import * as request from "../../../services/FetchService";
import NewButton from "../../Buttons/NewButton";

const AddCardNewTest = ({ getCards, param }) => {
	const { t } = useTranslation();
	const stripe = useStripe();
	const elements = useElements();
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!stripe || !elements) return;

		setLoading(true);

		try {
			// If you want to allow full-page redirects, set this to true and add confirmParams.return_url.
			const allowRedirect = false;

			const { error, setupIntent } = await stripe.confirmSetup({
				elements,
				redirect: "if_required"
				// confirmParams: allowRedirect ? { return_url: `${window.location.origin}/subscriptions` } : undefined,
				// If you don't want any redirects inside a modal, you can omit return_url.
			});

			if (error) {
				toast.error(error.message);
				return;
			}

			// Possible statuses: requires_action, processing, succeeded, etc.
			if (setupIntent?.status !== "succeeded") {
				if (setupIntent?.status === "requires_action") {
					toast.error(`SetupIntent status: ${setupIntent?.status || "unknown"}`);
					return;
				}
				toast.error(`SetupIntent status: ${setupIntent?.status || "unknown"}`);
				return;
			}

			const paymentMethodId = setupIntent.payment_method; // string id (pm_...)
			if (!paymentMethodId) {
				toast.error("Missing payment method id from SetupIntent.");
				return;
			}

			// Tell backend to attach pm to customer + set default + whatever else you need
			const backendRes = await request.postSubscription("", "payments/dataplan/cards/confirm", {
				setup_intent_id: setupIntent.id,
				payment_method: paymentMethodId,
			}, param);

			// Adjust based on your API shape
			if (!backendRes?.data?.successful && backendRes?.status !== 200) {
				toast.error(backendRes?.data?.message || "Failed to finalize card on backend");
				return;
			}

			await getCards?.();
			toast.success(t("toast.success"));
		} catch (err) {
			toast.error(err?.message || "Something went wrong");
		} finally {
			setLoading(false);
		}
	};

	return (
		<form onSubmit={handleSubmit}>
			<PaymentElement />
			<NewButton className="bg-grey-blue white bold p-3 rounded24 mt-3 w-100" type="submit" disabled={!stripe || loading}>
				{t("subscription.add_card")}
				<span className={`${loading ? "" : "d-none"} ms-2 size_15 spinner-grow`} />
			</NewButton>
		</form>
	);
};

export default AddCardNewTest;
